export default "__VITE_ASSET__c5c6b7a2__"